import {RequestError} from '../request';

function refreshToken() {
    return fetch(process.env.REACT_APP_API_URL + '/users/authentication', {
        method: 'POST',
        credentials: 'include',
        body: localStorage.getItem('refresh-token'),
        headers: {
            'Content-Type': 'text/plain',
        },
    });
}

export async function handleError(err: RequestError, request: () => Promise<Response>) {
    if (err.status === 401) {
        const auth = await refreshToken();
        if (auth && auth.status >= 200 && auth.status < 300) {
            return request();
        }
        err.message = 'Your session has expired!';
    }

    if (err.status === 500) {
        err.message = 'It seems that the server has encountered an error :/. A log was sent to the admin!';
    }

    throw err;
}